export default {
  tabela: {
    nome: 'Nome',
    condicao: 'Condição',
    descricao: 'Descrição',
  },
  titulo_modal: 'Condições de Pagamento',
};
